import script from "./Modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./Modal.vue?vue&type=script&setup=true&lang=ts"

import "./Modal.vue?vue&type=style&index=0&id=45e9ddbe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45e9ddbe"]])

export default __exports__